import { Flex } from 'components/shared/flex'
import { ThemeContext } from 'contexts/theme_context'
import { PcrRun } from 'entities/pcr_run'
import { useContext } from 'react'
import { OverlayTrigger, Popover, Table } from 'react-bootstrap'
import { FaQuestionCircle } from 'react-icons/fa'
import { PcrRunViewModel } from 'view_models/pcr_run_view_model'

type Props = {
    vm: PcrRunViewModel
    pcrRun: PcrRun
}

export const ExpProtocolV1 = (props: Props) => {
    const theme = useContext(ThemeContext)

    return (
        <div className="child-margin-c-15" style={{ fontWeight: 'bold', marginRight: 0 }}>
            {(() => {
                const dnaColumnCount = props.vm.dnaColumnCount()
                const dnaCount = props.pcrRun.dnaSet!.length + 1 // qPCR_standard
                const dnaRowCount = Math.ceil(dnaCount / dnaColumnCount)
                const baseDnaCount = dnaColumnCount * dnaRowCount
                const baseProbeCount = props.pcrRun.pcrRunProbes!.length
                const dnaDispenseCount = dnaRowCount
                const probeDispenseCount = props.pcrRun.pcrProtocol!.sampleCount! <= 8 ? 2 : 1
                const totalWellOfProbe = (baseDnaCount || 0) * 3
                const totalWellOfDna = baseProbeCount * 3
                const amountOfMasterMix = totalWellOfProbe * 6 + (dnaDispenseCount || 1) * 14
                const amountOfProbe = Math.round((totalWellOfProbe * 0.6 + (dnaDispenseCount || 1) * 1.4) * 100) / 100
                const amountOfNFW = Math.round((totalWellOfDna * 5.1 + (probeDispenseCount || 1) * 20.4) * 10) / 10
                const amountOfDna = Math.round((totalWellOfDna * 0.3 + (probeDispenseCount || 1) * 1.2) * 10) / 10
                const exDispense = Math.ceil((baseProbeCount || 0) / 4)

                return (
                    <>
                        <div style={{ backgroundColor: 'white', marginRight: 10 }} className="shadow">
                            <div style={{ background: theme.brand, padding: '5px 15px', color: 'white' }}>各種数量</div>
                            <div style={{ padding: 10 }}>
                                <Table style={{ backgroundColor: 'white', textAlign: 'center', verticalAlign: 'bottom' }}>
                                    <tbody>
                                        <tr>
                                            <th>
                                                <Flex alignItems="center">
                                                    <div>cDNA計算基準</div>
                                                    <OverlayTrigger
                                                        trigger="hover"
                                                        placement="top"
                                                        rootClose
                                                        overlay={
                                                            <Popover id="popover-hint" style={{ zIndex: 10000 }}>
                                                                <Popover.Body>cDNA数+qPCR_standard右列の空きwell数</Popover.Body>
                                                            </Popover>
                                                        }
                                                    >
                                                        <div style={{ marginBottom: 8, cursor: 'pointer' }}>
                                                            <FaQuestionCircle />
                                                        </div>
                                                    </OverlayTrigger>
                                                </Flex>
                                            </th>
                                            <th>Probe数</th>
                                            <th>1Probe総well数</th>
                                            <th>1cDNA総well数</th>
                                        </tr>
                                        <tr>
                                            <td>{baseDnaCount}</td>
                                            <td>{baseProbeCount}</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>cDNA計算基準 x 3</div>
                                                {totalWellOfProbe}
                                            </td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>Probe数 x 3</div>
                                                {totalWellOfDna}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                        <div style={{ backgroundColor: 'white', marginRight: 10 }} className="shadow">
                            <div style={{ background: theme.brand, padding: '5px 15px', color: 'white' }}>Probe数分、Reaction Mixを準備する</div>
                            <div style={{ padding: 10 }}>
                                <Table style={{ width: 'auto', backgroundColor: 'white', textAlign: 'center', verticalAlign: 'bottom' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: 120 }}>
                                                <div style={{ fontSize: 11 }}>1probe総well数</div>
                                                <div>{totalWellOfProbe}</div>
                                            </td>
                                            <td>x</td>
                                            <td>
                                                <div>6</div>
                                            </td>
                                            <td>+</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>分注数</div>
                                                <div style={{ width: 60 }}>{dnaDispenseCount}</div>
                                            </td>
                                            <td>x</td>
                                            <td>14</td>
                                            <td>=</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>Master Mix量</div>
                                                <div>{amountOfMasterMix}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: 120 }}>
                                                <div style={{ fontSize: 11 }}>1probe総well数</div>
                                                <div>{totalWellOfProbe}</div>
                                            </td>
                                            <td>x</td>
                                            <td>
                                                <div>0.6</div>
                                            </td>
                                            <td>+</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>分注数</div>
                                                <div style={{ width: 60 }}>{dnaDispenseCount}</div>
                                            </td>
                                            <td>x</td>
                                            <td>1.4</td>
                                            <td>=</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>Probe量</div>
                                                <div>{amountOfProbe}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: 120 }}>
                                                <div style={{ fontSize: 11 }}>MasterMix量</div>
                                                <div>{amountOfMasterMix}</div>
                                            </td>
                                            <td>+</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>Probe量</div>
                                                <div>{amountOfProbe}</div>
                                            </td>
                                            <td>=</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>Total</div>
                                                <div>{amountOfMasterMix + amountOfProbe}</div>
                                            </td>
                                            <td>÷</td>
                                            <td>{dnaDispenseCount}</td>
                                            <td>=</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>分注量</div>
                                                <div>{Math.floor((amountOfMasterMix + amountOfProbe) / (dnaDispenseCount || 1))}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        <div style={{ backgroundColor: 'white', marginRight: 10 }} className="shadow">
                            <div style={{ background: theme.brand, padding: '5px 15px', color: 'white' }}>
                                計算した本数分のReaction Mix を8連チューブに混合する
                            </div>
                            <div style={{ padding: 10 }}>
                                <Table style={{ width: 'auto', backgroundColor: 'white', textAlign: 'center', verticalAlign: 'bottom' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: 120 }}>
                                                <div style={{ fontSize: 11 }}>1cDNA総well数</div>
                                                <div>{totalWellOfDna}</div>
                                            </td>
                                            <td>x</td>
                                            <td>5.1</td>
                                            <td>+</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>分注数</div>
                                                <div style={{ width: 60 }}>{probeDispenseCount}</div>
                                            </td>
                                            <td>x</td>
                                            <td>20.4</td>
                                            <td>=</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>NFW量</div>
                                                <div>{amountOfNFW}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: 120 }}>
                                                <div style={{ fontSize: 11 }}>1cDNA総well数</div>
                                                <div>{totalWellOfDna}</div>
                                            </td>
                                            <td>x</td>
                                            <td>0.3</td>
                                            <td>+</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>分注数</div>
                                                <div style={{ width: 60 }}>{probeDispenseCount}</div>
                                            </td>
                                            <td>x</td>
                                            <td>
                                                <div>{1.2}</div>
                                            </td>
                                            <td>=</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>cDNA量</div>
                                                <div>{amountOfDna}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: 120 }}>
                                                <div style={{ fontSize: 11 }}>NFW量</div>
                                                <div>{amountOfNFW}</div>
                                            </td>
                                            <td>+</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>cDNA量</div>
                                                <div>{amountOfDna}</div>
                                            </td>
                                            <td>=</td>
                                            <td>
                                                <div style={{ fontSize: 11 }}>Total</div>
                                                <div>{Math.round((amountOfNFW + amountOfDna) * 10) / 10}</div>
                                            </td>
                                            {(baseDnaCount || 0) <= 8 ? (
                                                <>
                                                    <td>÷</td>
                                                    <td>{probeDispenseCount}</td>
                                                    <td>=</td>
                                                    <td>
                                                        <div style={{ fontSize: 11 }}>分注量</div>
                                                        <div>{Math.floor((amountOfNFW + amountOfDna) / probeDispenseCount)}</div>
                                                    </td>
                                                </>
                                            ) : (
                                                <td colSpan={4}></td>
                                            )}
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </>
                )
            })()}
        </div>
    )
}
